import {BlackfridayObserver} from './blackfriday.observer'
import {Observable} from 'rxjs'

export class BlackfridayComponent {
  constructor() {
    this.btnToggle = document.querySelector('[data-click="showBrands"]');
    this.listBrands = document.querySelectorAll('#menu-superior > li');
    this.toggleMarcas = document.querySelectorAll('[data-toggle="active-marcas"]');
    this.filtersElement = document.querySelector('.filters.filters-marcas')
    this.resultsElement = document.querySelector('.results')
    this.init();
  }

  init() {
    if (this.listBrands && this.btnToggle) {
      let btnClick = Observable.fromEvent(this.btnToggle, 'click');

      btnClick
        .map(ev => this.returnSliced(Array.from(this.listBrands)))
        .subscribe(new BlackfridayObserver(this.btnToggle));
    }

    if(this.toggleMarcas) {
      Array.prototype.forEach.call(this.toggleMarcas, el => {
        el.addEventListener('click', e => {
            document.body.classList.toggle('block-scroll-filters');
            this.filtersElement.classList.toggle('filters--actived')
            this.resultsElement.classList.toggle('results--reduced')
        })
      })
    }
  }

  returnSliced(elements) {
    return (elements.slice(37));
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/blackfriday/blackfriday.component.js